import React from "react";
import CurrencyInput from "../CurrencyInput/CurrencyInput";
import DateHelper from "../DateHelper/DateHelper";
import DatePickerInput from "../DatePickerInput/DatePickerInput";
import Errors from "../Errors/Errors";
import ErrorHelper from "../Errors/ErrorHelper";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

export default class BookingVouchers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: [],
      loading: false,

      amount: "",
      delivery_date: "",
      message: "",
      recipient_email: "",
      recipient_name: "",
    };

    this.onAddVoucher = this.onAddVoucher.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangeDeliveryDate = this.onChangeDeliveryDate.bind(this);
    this.onSelectAmount = this.onSelectAmount.bind(this);
  }

  render() {
    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();

          this.onAddVoucher(
            this.state.amount,
            this.state.delivery_date,
            this.state.recipient_name,
            this.state.recipient_email,
            this.state.message
          );
        }}
        className="BookingVouchers"
      >
        <Errors
          errors={this.state.errors}
          style={{ marginLeft: "0px", marginRight: "0px" }}
        />
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t("amount")}</label>
              <CurrencyInput
                name="amount"
                value={this.state.amount}
                onChange={this.onSelectAmount}
                placeholder="100"
                className={ErrorHelper.renderFieldClasses(
                  "amount",
                  this.state.errors,
                  "form-control"
                )}
              />
              {ErrorHelper.renderFieldErrors("amount", this.state.errors)}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="message">{I18n.t("send_date")}</label>
              <DatePickerInput
                name="delivery_date"
                dateFormat={DateHelper.rubyToDateFNS(this.props.date_format)}
                selectedDate={this.state.delivery_date}
                placeholder={DateHelper.printDateToScreen(
                  new Date(),
                  this.props.date_format
                )}
                onChange={this.onChangeDeliveryDate}
                className={ErrorHelper.renderFieldClasses(
                  "delivery_date",
                  this.state.errors,
                  "form-control"
                )}
              />
              {ErrorHelper.renderFieldErrors(
                "delivery_date",
                this.state.errors
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t("recipient_details")}</label>
              <input
                type="text"
                className={ErrorHelper.renderFieldClasses(
                  "recipient_name",
                  this.state.errors,
                  "form-control"
                )}
                name="recipient_name"
                value={this.state.recipient_name}
                placeholder={I18n.t("name")}
                onChange={this.onChange}
              />
              {ErrorHelper.renderFieldErrors(
                "recipient_name",
                this.state.errors
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>&nbsp;</label>
              <input
                type="email"
                className={ErrorHelper.renderFieldClasses(
                  "recipient_email",
                  this.state.errors,
                  "form-control"
                )}
                name="recipient_email"
                value={this.state.recipient_email}
                placeholder={I18n.t("email")}
                onChange={this.onChange}
              />
              {ErrorHelper.renderFieldErrors(
                "recipient_email",
                this.state.errors
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label htmlFor="message">{I18n.t("message")}</label>
              <textarea
                rows={5}
                className={ErrorHelper.renderFieldClasses(
                  "message",
                  this.state.errors,
                  "form-control"
                )}
                name="message"
                value={this.state.message}
                placeholder={I18n.t("add_an_optional_message")}
                onChange={this.onChange}
              />
              {ErrorHelper.renderFieldErrors("message", this.state.errors)}
            </div>
          </div>
        </div>
        <button type="submit" className="btn btn-outline btn-block add-to-cart">
          {I18n.t("add_to_cart")}
        </button>
        <LoadingSpinner show={this.state.loading} />
      </form>
    );
  }

  onAddVoucher(
    amount,
    delivery_date,
    recipient_name,
    recipient_email,
    message
  ) {
    this.setState({ errors: [], loading: true });

    $.ajax({
      type: "POST",
      url: this.props.validate_voucher_path,
      data: {
        api_key: this.props.account.api_key,
        property_id: this.props.property.id,
        voucher: {
          amount: amount,
          delivery_date: delivery_date,
          recipient_name: recipient_name,
          recipient_email: recipient_email,
          message: message,
        },
      },
    }).done((data) => {
      if (data && data.errors) {
        this.setState({ errors: data.errors, loading: false });
      } else {
        this.setState(
          {
            loading: false,
            amount: "",
            delivery_date: "",
            message: "",
            recipient_email: "",
            recipient_name: "",
          },
          () => {
            this.props.onAddVoucher(
              amount,
              delivery_date,
              recipient_name,
              recipient_email,
              message
            );
          }
        );
      }
    });
  }

  onChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  onChangeDeliveryDate(date) {
    this.setState({ delivery_date: date });
  }

  onSelectAmount(amount) {
    this.setState({ amount: amount });
  }
}
